// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-blocks[data-v-bf589ff0]{text-align:center}.color-blocks__grid[data-v-bf589ff0]{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));grid-gap:1rem;padding-bottom:4rem;padding-top:2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
